// Settings Categories Enum
// This file contains just the enum without UI dependencies to avoid circular imports

export enum SettingsCategory {
	General = 'General',
	Keyboard = 'Keyboard',
	Display = 'Display',
	PrivacySecurity = 'Privacy and security',
	TLS = 'TLS',
	WorkspaceUpdate = 'Workspace update',
	Shortcuts = 'Shortcuts',
	SoundAndCamera = 'Sound and camera',
	Devices = 'Devices',
	Mouse = 'Mouse',
	AccountManagement = 'Account',
	AddStore = 'AddStore',
	CollectLogs = 'Collect logs',
	SendFeedback = 'Send feedback',
	CheckConfiguration = 'Check configuration',
	ResetCWA = 'Reset Citrix Workspace',
	HelpDocumentation = 'Help documentation',
}

// Category descriptions for documentation
export const SETTINGS_CATEGORY_DESCRIPTIONS: Record<SettingsCategory, string> = {
	[SettingsCategory.General]: 'Basic application settings and preferences',
	[SettingsCategory.Keyboard]: 'Keyboard shortcuts and input settings',
	[SettingsCategory.Display]: 'Display and appearance settings',
	[SettingsCategory.PrivacySecurity]: 'Authentication and security settings',
	[SettingsCategory.TLS]: 'TLS encryption and security settings',
	[SettingsCategory.WorkspaceUpdate]: 'Application update settings and preferences',
	[SettingsCategory.Shortcuts]: 'Application shortcut management settings',
	[SettingsCategory.SoundAndCamera]: 'Audio and video device settings',
	[SettingsCategory.Devices]: 'Connected device settings and preferences',
	[SettingsCategory.Mouse]: 'Mouse and pointing device settings',
	[SettingsCategory.AccountManagement]: 'Manage stores and account configuration',
	[SettingsCategory.AddStore]: 'Add a new store to your workspace',
	[SettingsCategory.CollectLogs]:
		'Collect and export application logs for troubleshooting',
	[SettingsCategory.SendFeedback]: 'Send feedback to Citrix about your experience',
	[SettingsCategory.CheckConfiguration]: 'Check and verify the application configuration',
	[SettingsCategory.ResetCWA]: 'Reset Citrix Workspace app to its default state',
	[SettingsCategory.HelpDocumentation]: 'Access help documentation and support resources',
};
